import ScrollHint from 'scroll-hint'

document.addEventListener('DOMContentLoaded', function () {
  // すべてのtable要素を取得
  const tables = document.querySelectorAll('.spec-table');

  tables.forEach(function (table) {
    // 新しいdiv要素を作成
    const wrapper = document.createElement('div');
    wrapper.classList.add('js-scrollable', 'scroll-hint'); // scroll-hintクラスを追加

    // 親ノードにdivを追加し、その中にtableを移動
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });

  // ScrollHintを適用
  new ScrollHint('.scroll-hint', {
    scrollHintIconAppendClass: 'scroll-hint-icon-white', // 必要に応じてカスタマイズ
  });
});
